import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // default localStorage
import { combineReducers } from 'redux';
import dumpsterReducer from '../features/dumpsters/dumpsterSlice';
import orderReducer from '../features/orders/orderSlice';
import billingReducer from '../features/billing/billingSlice';
import authReducer from '../features/auth/authSlice';
import mediaReducer from '../features/media/mediaSlice';
import wasteTypeReducer from '../features/wasteTypes/wasteTypeSlice';
// Persist config (excluding dumpsters)
const persistConfig = {
  key: 'root',
  storage,
};

// Combine reducers
const rootReducer = combineReducers({
  dumpsters: dumpsterReducer,
  orders: orderReducer,
  billing: billingReducer,
  auth: authReducer,
  media: mediaReducer,
  wasteTypes: wasteTypeReducer,
});

// Persist the combined reducer (excluding dumpsters)
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export default store;
